import { render, staticRenderFns } from "./AnswerText.vue?vue&type=template&id=5598ed65&scoped=true"
import script from "./AnswerText.vue?vue&type=script&lang=js"
export * from "./AnswerText.vue?vue&type=script&lang=js"
import style0 from "./AnswerText.vue?vue&type=style&index=0&id=5598ed65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598ed65",
  null
  
)

export default component.exports